import MiniBasket from "./components/mini-basket";
import AddToBasketButton from "./components/add-to-basket-button";
import $ from "jquery";
import Dropdown from "bootstrap/js/src/dropdown";
import Collapse from "bootstrap/js/src/collapse";
import Tab from "bootstrap/js/src/tab";

MiniBasket.init();
AddToBasketButton.init();

/**
 * Prevent Bootstrap dropdown closing when clicking inside the dropdown.
 */
$(document).on('hide.bs.dropdown', function (event) {
    if (event.clickEvent && event.clickEvent.originalEvent.target.closest('.dropdown-menu')) {
        event.preventDefault();
    }
});

$('.mobile-menu').on('show.bs.collapse', function (evnent) {
    document.body.classList.add('mobile-menu-visible');
});

$('.mobile-menu').on('hide.bs.collapse', function (evnent) {
    document.body.classList.remove('mobile-menu-visible');
});